import React, { useState } from 'react';
import LoadingFullScreen from '../../components/LoadingFullScreen';
import { redirectToApp } from '../../utils/common';
import CountDown from '../../components/CountDown';
import Modal from '../../components/ModalOTP';
import { makeStyles } from '@material-ui/core/styles';
import { useMst } from '../../models/Root';
import { observer } from 'mobx-react-lite';
import './index.css';

const display = process.env.NODE_ENV !== "production"
const useStyles = makeStyles(theme  => ({
    loadingTitle: {
        textAlign: 'center',
        fontSize: '20px',
        lineHeight: '32px',
        fontFamily: 'Roboto',
        fontWeight: "500",
        color: '#000000'
    },
    loadingDes: {
        textAlign: 'center',
        fontSize: '16px',
        lineHeight: '24px',
        fontFamily: 'Roboto',
        fontWeight: "normal",
        color: '#000000',
        marginTop: '8px',
        padding: '0 32px'
    }
}))

export default observer(() => {
    const [isOpen, setOpen] = useState(false);
    const [modalState] = useState({title: "Phiên nhập OTP hết hạn", content: `Bạn vui lòng chọn "Đóng" và thử lại sau nhé!`})

    const { title, content } = modalState;
    const { otp: { isOpenDialog, setOpenDialog },analytics } = useMst();
    const classes = useStyles();
    const timeUp = (isTimeUp = false) => {
        if (isTimeUp && !isOpenDialog) {
            setOpenDialog();
            setOpen(true);
            analytics.logEvent('otp_session_expired')
        }
    }

    const handleClose = () => {
        console.log("close Loading.js")
        setOpen(false);
        analytics.logEvent('otp_dialog_close')
        redirectToApp();
    }

    return (
        <div className="main">
            <LoadingFullScreen />
            <span className={classes.loadingTitle}>Đang xử lý…</span>
            <span className={classes.loadingDes}>Chờ một chút trong khi chúng tôi xử lý yêu cầu của bạn</span>
            <CountDown display={display} styles={{display: 'flex', justifyContent: 'center'}} initialMinute={5} initialSeconds={0} timeUp={timeUp} /> 
            <Modal
                isShowDialog={isOpen}
                title={title}
                content={content}
                close={handleClose}
            />
        </div>
    )
})